// In src/pages/VolunteerReportPage.js

import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { db } from '../services/firebase';
import { collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import {
  Container, Typography, Paper, List, ListItem, ListItemText,
  CircularProgress, Divider, Avatar,
} from '@mui/material';

function VolunteerReportPage() {
  const { userProfile } = useAuth();
  const [usersWithHours, setUsersWithHours] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userProfile?.churchId) return;

    const usersQuery = query(
      collection(db, 'users'),
      where('churchId', '==', userProfile.churchId),
      where('totalVolunteerHours', '>', 0),
      orderBy('totalVolunteerHours', 'desc')
    );

    const unsubscribe = onSnapshot(usersQuery, (snapshot) => {
      const usersData = snapshot.docs.map(d => ({ id: d.id, ...d.data() }));
      setUsersWithHours(usersData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [userProfile?.churchId]);

  if (loading) return <CircularProgress />;

  return (
    <Container maxWidth="md">
      <Typography variant="h4" gutterBottom>Volunteer Hours Report</Typography>
      <Paper>
        <List>
          {usersWithHours.length === 0 && (
            <ListItem><ListItemText primary="No members have logged volunteer hours yet." /></ListItem>
          )}
          {usersWithHours.map((user, index) => (
            <React.Fragment key={user.id}>
              <ListItem>
                <Avatar sx={{ mr: 2 }} src={user.profilePhotoUrl || ''} />
                <ListItemText
                  primary={`${user.firstName} ${user.lastName}`}
                  secondary={`Role: ${user.role}`}
                />
                <Typography variant="h6">{user.totalVolunteerHours.toFixed(1)} hrs</Typography>
              </ListItem>
              {index < usersWithHours.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Paper>
    </Container>
  );
}

export default VolunteerReportPage;